import type { IMediumDto } from '../model/interface/model';

const EXTENSIONS_IMAGE = new Set(['avif', 'jpeg', 'jpg', 'png', 'webp']);
const EXTENSIONS_VIDEO = new Set(['ts', 'mp4']);
const EXTENSIONS_AUDIO = new Set([
    'aac',
    'aiff',
    'alac',
    'flac',
    'mp3',
    'mp4a',
    'ogg',
    'opus',
    'pcm',
    'wav',
    'wma',
]);
const EXTENSIONS_ZIP = new Set(['.zip']);

const MIME_TYPES_ZIP = new Set(['application/x-zip-compressed', 'application/zip']);

const _fileExtension = (medium: IMediumDto) =>
    medium.fileName.toLowerCase().split('.').at(-1) ?? '';

function isImage(medium: IMediumDto): boolean {
    return medium.mimeType.startsWith('image/') || EXTENSIONS_IMAGE.has(_fileExtension(medium));
}

function isAudio(medium: IMediumDto): boolean {
    return medium.mimeType.startsWith('audio/') || EXTENSIONS_AUDIO.has(_fileExtension(medium));
}

function isVideo(medium: IMediumDto): boolean {
    return medium.mimeType.startsWith('video/') || EXTENSIONS_VIDEO.has(_fileExtension(medium));
}

function isZip(medium: IMediumDto): boolean {
    return MIME_TYPES_ZIP.has(medium.mimeType) || EXTENSIONS_ZIP.has(_fileExtension(medium));
}

export default Object.freeze({
    isImage,
    isAudio,
    isVideo,
    isZip,
});
